import axios, { AxiosResponse } from 'axios';
import { put, select, takeLatest } from 'redux-saga/effects';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';
import actions from '@state/actions';
import { serverError } from '@state/auth/actions';
import selectors from '@state/selectors';
import host from '@utils/host';
import {updateRole} from '@utils/userUtils';

function* signIn(action: actionsInterfaces.ISignInAction) {
  try {
    const response: AxiosResponse<any> = yield axios.post(`${host}signin`, {user: action.user.profile.email , secret: action.user.access_token, dsPermissions: action.dsPermissions})
    if (response.status >= 200 && response.status <= 300) {
      action = updateRole(action,  response.data.dsPermissions);      
      yield put(actions.auth.setAuth(action.userManager, action.user, response.data.token));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      yield action.userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* publicSignIn(action: actionsInterfaces.IPublicSignInAction) {
  try {
    const response: AxiosResponse<any> = yield axios.post(`${host}public-signin`, {shareToken: action.shareToken})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.auth.setAuth(action.userManager, action.user ?? response.data.metadata, response.data.token));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      yield action.userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* createShareToken(action: actionsInterfaces.ICreateShareTokenAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.post(`${host}create-sharetoken`, {type: action.entityType, id: action.entityId}, {headers: {Authorization: token}});
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.auth.setShareToken(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

export default function* budgetSagas() {
  yield takeLatest(actionsTypes.SIGN_IN, signIn);
  yield takeLatest(actionsTypes.PUBLIC_SIGN_IN, publicSignIn);
  yield takeLatest(actionsTypes.CREATE_SHARE_TOKEN, createShareToken);
}

